module.exports = __webpack_public_path__ + "static/media/climate_water_floodZones.9e723ca0.jpg";